var ParticleAnimationData = (function () {
    function ParticleAnimationData() {
    }
    return ParticleAnimationData;
}());
export { ParticleAnimationData };
